var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v("Home")]),_c('dl',[_c('dt',[_vm._v("Team Name")]),_c('dd',[_vm._v(_vm._s(this.name))]),_c('dt',[_vm._v("Your Team URL")]),_c('dd',[_vm._v("https://www.bitscheduler.com/home/"+_vm._s(this.teamKey))])])])}
var staticRenderFns = []

export { render, staticRenderFns }